import { Box, Flex } from '@chakra-ui/react'
import React from 'react'
import { VIEW_WIDTH, VIEW_WIDTH_SM } from '../../constants/views.constant'

export const ViewWrapper:React.FC<{children: any}> = ({children}) => {
  return (
    <Box
    width={{ base: VIEW_WIDTH_SM, md: VIEW_WIDTH }}
    height="95vh"
    bg="#fff"
    // mt="2.75em"
    borderRadius={"15px"}
    p="2"
    shadow="lg"
  >
    <Box margin={8}>
      {children}
    </Box>
  </Box>
  )
}
